


// import React, { useContext, useMemo, useState, useEffect } from 'react';
// import { PageTitle, Card, LoadingSkeleton } from '../components/common';
// import { AuthContext } from '../contexts/AuthContext';
// import { mockCourses, mockEnrollments, mockProjects } from '../mockData';
// import { UserMode, Task } from '../types';
// import { Link } from 'react-router-dom';
// import { ResponsiveContainer, PieChart, Pie, Cell, Legend, RadialBarChart, RadialBar, PolarAngleAxis, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip } from 'recharts';

// const useCountUp = (end: number, duration: number = 1000) => {
//     const [count, setCount] = useState(0);
//     useEffect(() => {
//         let start = 0;
//         const startTime = Date.now();
//         const animate = () => {
//             const now = Date.now();
//             const progress = Math.min((now - startTime) / duration, 1);
//             const current = Math.floor(progress * (end - start) + start);
//             setCount(current);
//             if (progress < 1) {
//                 requestAnimationFrame(animate);
//             }
//         };
//         requestAnimationFrame(animate);
//     }, [end, duration]);
//     return count;
// };

// const StatCard: React.FC<{ title: string; value: number; icon: React.ReactElement<{ className?: string }>; color: string }> = ({ title, value, icon, color }) => {
//     const count = useCountUp(value);
//     return (
//         <Card className={`p-4 flex items-center overflow-hidden relative ${color}`}>
//             <div className="p-3 rounded-full bg-white/20 text-white mr-4">{React.cloneElement(icon, { className: "w-8 h-8" })}</div>
//             <div>
//                 <p className="text-sm text-white/80">{title}</p>
//                 <p className="text-3xl font-bold text-white">{count}</p>
//             </div>
//              <div className="absolute -bottom-4 -right-4 text-white/10">
//                 {React.cloneElement(icon, { className: "w-24 h-24" })}
//             </div>
//         </Card>
//     );
// };

// // Online Dashboard Icons
// const BookOpenIcon = ({className = "w-6 h-6"}) => <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path></svg>;
// const PlayCircleIcon = ({className = "w-6 h-6"}) => <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><polygon points="10 8 16 12 10 16 10 8"></polygon></svg>;
// const CheckCircleIcon = ({className = "w-6 h-6"}) => <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>;
// const AwardIcon = ({className = "w-6 h-6"}) => <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="8" r="7"></circle><polyline points="8.21 13.89 7 23 12 17 17 23 15.79 13.88"></polyline></svg>;

// // Offline Dashboard Icons
// const ListTodoIcon = ({className = "w-6 h-6"}) => <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="5" width="6" height="6" rx="1" /><path d="m3 17 2 2 4-4" /><path d="M13 6h8" /><path d="M13 12h8" /><path d="M13 18h8" /></svg>;
// const RefreshCwIcon = ({className = "w-6 h-6"}) => <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8" /><path d="M21 3v5h-5" /><path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16" /><path d="M3 21v-5h5" /></svg>;
// const CheckCheckIcon = ({className = "w-6 h-6"}) => <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 6 7 17l-5-5" /><path d="m22 10-7.5 7.5L13 16" /></svg>;
// const ClipboardListIcon = ({className = "w-6 h-6"}) => <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect width="8" height="4" x="8" y="2" rx="1" ry="1" /><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" /><path d="M12 11h4" /><path d="M12 16h4" /><path d="M8 11h.01" /><path d="M8 16h.01" /></svg>;


// const RADIAL_CHART_COLORS = ['#dc2626', '#f59e0b', '#8b5cf6', '#22c55e'];
// const PIE_CHART_COLORS = ['#3b82f6', '#f97316', '#8b5cf6', '#16a34a'];
// const BAR_CHART_COLORS = ["#ef4444", "#f97316", "#3b82f6"];

// const OnlineDashboard = () => {
//     const auth = useContext(AuthContext);
//     const { enrolledCount, activeCount, completedCount, certificatesCount } = useMemo(() => {
//         const user = auth?.currentUser;
//         if (!user) return { enrolledCount: 0, activeCount: 0, completedCount: 0, certificatesCount: 0 };

//         const enrolled = mockCourses.filter(c => user.enrolledCourseIds.includes(c.id));
//         const userEnrollments = mockEnrollments.filter(e => e.userId === user.id);
        
//         const completed = enrolled.filter(course => {
//             const enrollment = userEnrollments.find(e => e.courseId === course.id);
//             const totalLessons = (course.sections || []).flatMap(s => s.lessons).length;
//             return enrollment && totalLessons > 0 && enrollment.completedLessonIds.length === totalLessons;
//         });

//         return {
//             enrolledCount: enrolled.length,
//             activeCount: enrolled.length - completed.length,
//             completedCount: completed.length,
//             certificatesCount: completed.length // Assuming one certificate per completed course
//         };
//     }, [auth?.currentUser]);

//     const overallCompletion = enrolledCount > 0 ? (completedCount / enrolledCount) * 100 : 0;
//     const radialChartData = [{ name: 'Completion', value: overallCompletion, fill: RADIAL_CHART_COLORS[0] }];

//     const statusData = [
//         { name: 'Active Courses', value: activeCount, fill: PIE_CHART_COLORS[0] },
//         { name: 'Completed Courses', value: completedCount, fill: PIE_CHART_COLORS[1] }
//     ];

//      const RADIAN = Math.PI / 180;
//     const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index }: any) => {
//         const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
//         const x = cx + radius * Math.cos(-midAngle * RADIAN);
//         const y = cy + radius * Math.sin(-midAngle * RADIAN);
//         const p = percent || 0; // handle case where percent is undefined

//         return (
//             <text x={x} y={y} fill="white" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central">
//                 {`${(p * 100).toFixed(0)}%`}
//             </text>
//         );
//     };

//     return (
//         <div className="space-y-6">
//             <PageTitle title="Dashboard" subtitle={`Welcome back, ${auth?.currentUser?.firstName}!`} />
//             <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
//                 <StatCard title="Enrolled Courses" value={enrolledCount} icon={<BookOpenIcon />} color="bg-gradient-to-r from-blue-500 to-blue-400" />
//                 <StatCard title="Active Courses" value={activeCount} icon={<PlayCircleIcon />} color="bg-gradient-to-r from-green-500 to-green-400" />
//                 <StatCard title="Completed Courses" value={completedCount} icon={<CheckCircleIcon />} color="bg-gradient-to-r from-yellow-500 to-yellow-400" />
//                 <StatCard title="Certificates Earned" value={certificatesCount} icon={<AwardIcon />} color="bg-gradient-to-r from-red-500 to-red-400" />
//             </div>

//             <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
//                 <Card className="lg:col-span-2 p-4">
//                     <h3 className="font-bold text-lg mb-4 text-gray-800">Course Status</h3>
//                     <ResponsiveContainer width="100%" height={300}>
//                         <PieChart>
//                             <Pie
//                                 data={statusData}
//                                 dataKey="value"
//                                 nameKey="name"
//                                 cx="50%"
//                                 cy="50%"
//                                 outerRadius={120}
//                                 labelLine={false}
//                                 label={renderCustomizedLabel}
//                             >
//                                 {statusData.map((entry, index) => (
//                                     <Cell key={`cell-${index}`} fill={PIE_CHART_COLORS[index % PIE_CHART_COLORS.length]} />
//                                 ))}
//                             </Pie>
//                             <Tooltip />
//                             <Legend />
//                         </PieChart>
//                     </ResponsiveContainer>
//                 </Card>
//                 <Card className="p-4">
//                     <h3 className="font-bold text-lg mb-4 text-gray-800">Overall Completion</h3>
//                      <ResponsiveContainer width="100%" height={300}>
//                         <RadialBarChart 
//                             innerRadius="70%" 
//                             outerRadius="90%" 
//                             data={radialChartData} 
//                             startAngle={90} 
//                             endAngle={-270}
//                         >
//                             <PolarAngleAxis
//                                 type="number"
//                                 domain={[0, 100]}
//                                 angleAxisId={0}
//                                 tick={false}
//                             />
//                             <RadialBar
//                                 background
// // FIX: Changed from clockwise to clockWise, which is the correct prop name for recharts.
//                                 // clockWise
//                                 dataKey="value"
//                                 cornerRadius={10}
//                             />
//                              <text
//                                 x="50%"
//                                 y="50%"
//                                 textAnchor="middle"
//                                 dominantBaseline="middle"
//                                 className="text-4xl font-bold fill-current text-gray-800"
//                             >
//                                 {`${Math.round(overallCompletion)}%`}
//                             </text>
//                         </RadialBarChart>
//                     </ResponsiveContainer>
//                 </Card>
//             </div>
//         </div>
//     );
// };

// const OfflineDashboard = () => {
//     const allTasks = useMemo(() => mockProjects.flatMap(p => p.features.flatMap(f => f.tasks)), []);

//     const taskStats = useMemo(() => {
//         const total = allTasks.length;
//         const todo = allTasks.filter(t => t.status === 'To Do').length;
//         const inProgress = allTasks.filter(t => t.status === 'In Progress').length;
//         const completed = allTasks.filter(t => t.status === 'Done').length;
//         return { total, todo, inProgress, completed };
//     }, [allTasks]);

//     const statusData = [
//         { name: 'To Do', value: taskStats.todo },
//         { name: 'In Progress', value: taskStats.inProgress },
//         { name: 'In Review', value: allTasks.filter(t => t.status === 'In Review').length },
//         { name: 'Done', value: taskStats.completed },
//     ];
    
//     const priorityData = [
//         { name: 'High', count: allTasks.filter(t => t.priority === 'High').length },
//         { name: 'Medium', count: allTasks.filter(t => t.priority === 'Medium').length },
//         { name: 'Low', count: allTasks.filter(t => t.priority === 'Low').length },
//     ];
    
//     const RADIAN = Math.PI / 180;
//     const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, value, index }: any) => {
//         const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
//         const x = cx + radius * Math.cos(-midAngle * RADIAN);
//         const y = cy + radius * Math.sin(-midAngle * RADIAN);

//         return (
//             <text x={x} y={y} fill="white" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central" className="font-bold text-sm">
//                 {value}
//             </text>
//         );
//     };

//     return (
//         <div className="space-y-6">
//             <PageTitle title="Dashboard" subtitle="Here’s a quick overview of your tasks." />
//             <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
//                 <StatCard title="Total Tasks" value={taskStats.total} icon={<ClipboardListIcon />} color="bg-gradient-to-r from-yellow-500 to-yellow-400" />
//                 <StatCard title="To Do" value={taskStats.todo} icon={<ListTodoIcon />} color="bg-gradient-to-r from-orange-500 to-orange-400" />
//                 <StatCard title="In Progress" value={taskStats.inProgress} icon={<RefreshCwIcon />} color="bg-gradient-to-r from-red-500 to-red-400" />
//                 <StatCard title="Completed" value={taskStats.completed} icon={<CheckCheckIcon />} color="bg-gradient-to-r from-green-500 to-green-400" />
//             </div>

//             <div className="grid grid-cols-1 lg:grid-cols-5 gap-6">
//                 <Card className="lg:col-span-2 p-4">
//                      <h3 className="font-bold text-lg mb-4 text-gray-800">Tasks by Status</h3>
//                      <ResponsiveContainer width="100%" height={300}>
//                          <PieChart>
//                             <Pie
//                                 data={statusData}
//                                 dataKey="value"
//                                 nameKey="name"
//                                 cx="50%"
//                                 cy="50%"
//                                 outerRadius={100}
//                                 label={renderCustomizedLabel}
//                                 labelLine={false}
//                             >
//                                 {statusData.map((entry, index) => (
//                                     <Cell key={`cell-${index}`} fill={PIE_CHART_COLORS[index % PIE_CHART_COLORS.length]} />
//                                 ))}
//                             </Pie>
//                             <Tooltip />
//                             <Legend />
//                         </PieChart>
//                      </ResponsiveContainer>
//                 </Card>
//                  <Card className="lg:col-span-3 p-4">
//                      <h3 className="font-bold text-lg mb-4 text-gray-800">Tasks by Priority</h3>
//                      <ResponsiveContainer width="100%" height={300}>
//                         <BarChart data={priorityData} margin={{ top: 5, right: 20, left: -10, bottom: 5 }}>
//                             <CartesianGrid strokeDasharray="3 3" />
//                             <XAxis dataKey="name" />
//                             <YAxis allowDecimals={false} />
//                             <Tooltip />
//                             <Bar dataKey="count" name="Tasks">
//                                  {priorityData.map((entry, index) => (
//                                     <Cell key={`cell-${index}`} fill={BAR_CHART_COLORS[index % BAR_CHART_COLORS.length]} />
//                                 ))}
//                             </Bar>
//                         </BarChart>
//                     </ResponsiveContainer>
//                 </Card>
//             </div>
//         </div>
//     );
// };

// const DashboardPage: React.FC = () => {
//     const auth = useContext(AuthContext);
//     const [isLoading, setIsLoading] = useState(true);

//     useEffect(() => {
//         const timer = setTimeout(() => setIsLoading(false), 300);
//         return () => clearTimeout(timer);
//     }, []);

//     if (isLoading || !auth?.currentUser) {
//         return (
//             <div>
//                 <LoadingSkeleton className="h-9 w-1/3 mb-4" />
//                 <LoadingSkeleton className="h-5 w-1/2 mb-8" />
//                 <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
//                     {[...Array(4)].map((_, i) => <LoadingSkeleton key={i} className="h-28 rounded-xl" />)}
//                 </div>
//                  <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mt-6">
//                     <LoadingSkeleton className="lg:col-span-2 h-80 rounded-xl" />
//                     <LoadingSkeleton className="h-80 rounded-xl" />
//                 </div>
//             </div>
//         );
//     }
    
//     return auth.currentUser.mode === 'online' ? <OnlineDashboard /> : <OfflineDashboard />;
// };

// export default DashboardPage;

import React, { useContext, useMemo, useState, useEffect } from 'react';
import { PageTitle, Card, LoadingSkeleton } from '../components/common';
import { AuthContext } from '../contexts/AuthContext';
import { mockCourses, mockEnrollments, mockProjects } from '../mockData';
import { UserMode, Task } from '../types';
import { Link } from 'react-router-dom';
import { ResponsiveContainer, PieChart, Pie, Cell, Legend, RadialBarChart, RadialBar, PolarAngleAxis, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip } from 'recharts';
import { getTraineeDashboard } from '../services/api';

// Update interface for API response based on your actual response
interface StatusCounts {
  TOD123: number;
  INP123: number;
  INR123: number;
  DON123: number;
}

interface PriorityCounts {
  low: number;
  medium: number;
  high: number;
  critical: number;
}

interface TraineeDashboardResponse {
  statusCounts: StatusCounts;
  priorityCounts: PriorityCounts;
}

const useCountUp = (end: number, duration: number = 1000) => {
    const [count, setCount] = useState(0);
    useEffect(() => {
        let start = 0;
        const startTime = Date.now();
        const animate = () => {
            const now = Date.now();
            const progress = Math.min((now - startTime) / duration, 1);
            const current = Math.floor(progress * (end - start) + start);
            setCount(current);
            if (progress < 1) {
                requestAnimationFrame(animate);
            }
        };
        requestAnimationFrame(animate);
    }, [end, duration]);
    return count;
};

const StatCard: React.FC<{ title: string; value: number; icon: React.ReactElement<{ className?: string }>; color: string }> = ({ title, value, icon, color }) => {
    const count = useCountUp(value);
    return (
        <Card className={`p-4 flex items-center overflow-hidden relative ${color}`}>
            <div className="p-3 rounded-full bg-white/20 text-white mr-4">{React.cloneElement(icon, { className: "w-8 h-8" })}</div>
            <div>
                <p className="text-sm text-white/80">{title}</p>
                <p className="text-3xl font-bold text-white">{count}</p>
            </div>
             <div className="absolute -bottom-4 -right-4 text-white/10">
                {React.cloneElement(icon, { className: "w-24 h-24" })}
            </div>
        </Card>
    );
};

// Online Dashboard Icons
const BookOpenIcon = ({className = "w-6 h-6"}) => <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path></svg>;
const PlayCircleIcon = ({className = "w-6 h-6"}) => <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><polygon points="10 8 16 12 10 16 10 8"></polygon></svg>;
const CheckCircleIcon = ({className = "w-6 h-6"}) => <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>;
const AwardIcon = ({className = "w-6 h-6"}) => <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="8" r="7"></circle><polyline points="8.21 13.89 7 23 12 17 17 23 15.79 13.88"></polyline></svg>;

// Offline Dashboard Icons
const ListTodoIcon = ({className = "w-6 h-6"}) => <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="5" width="6" height="6" rx="1" /><path d="m3 17 2 2 4-4" /><path d="M13 6h8" /><path d="M13 12h8" /><path d="M13 18h8" /></svg>;
const RefreshCwIcon = ({className = "w-6 h-6"}) => <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8" /><path d="M21 3v5h-5" /><path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16" /><path d="M3 21v-5h5" /></svg>;
const CheckCheckIcon = ({className = "w-6 h-6"}) => <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 6 7 17l-5-5" /><path d="m22 10-7.5 7.5L13 16" /></svg>;
const ClipboardListIcon = ({className = "w-6 h-6"}) => <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect width="8" height="4" x="8" y="2" rx="1" ry="1" /><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" /><path d="M12 11h4" /><path d="M12 16h4" /><path d="M8 11h.01" /><path d="M8 16h.01" /></svg>;
const EyeIcon = ({className = "w-6 h-6"}) => <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z"/><circle cx="12" cy="12" r="3"/></svg>;


const RADIAL_CHART_COLORS = ['#dc2626', '#f59e0b', '#8b5cf6', '#22c55e'];
const PIE_CHART_COLORS = ['#3b82f6', '#f97316', '#8b5cf6', '#16a34a'];
const BAR_CHART_COLORS = ["#ef4444", "#f97316", "#3b82f6", "#dc2626"];

const OnlineDashboard = () => {
    const auth = useContext(AuthContext);
    const { enrolledCount, activeCount, completedCount, certificatesCount } = useMemo(() => {
        const user = auth?.currentUser;
        if (!user) return { enrolledCount: 0, activeCount: 0, completedCount: 0, certificatesCount: 0 };

        const enrolled = mockCourses.filter(c => user.enrolledCourseIds.includes(c.id));
        const userEnrollments = mockEnrollments.filter(e => e.userId === user.id);
        
        const completed = enrolled.filter(course => {
            const enrollment = userEnrollments.find(e => e.courseId === course.id);
            const totalLessons = (course.sections || []).flatMap(s => s.lessons).length;
            return enrollment && totalLessons > 0 && enrollment.completedLessonIds.length === totalLessons;
        });

        return {
            enrolledCount: enrolled.length,
            activeCount: enrolled.length - completed.length,
            completedCount: completed.length,
            certificatesCount: completed.length // Assuming one certificate per completed course
        };
    }, [auth?.currentUser]);

    const overallCompletion = enrolledCount > 0 ? (completedCount / enrolledCount) * 100 : 0;
    const radialChartData = [{ name: 'Completion', value: overallCompletion, fill: RADIAL_CHART_COLORS[0] }];

    const statusData = [
        { name: 'Active Courses', value: activeCount, fill: PIE_CHART_COLORS[0] },
        { name: 'Completed Courses', value: completedCount, fill: PIE_CHART_COLORS[1] }
    ];

     const RADIAN = Math.PI / 180;
    const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index }: any) => {
        const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
        const x = cx + radius * Math.cos(-midAngle * RADIAN);
        const y = cy + radius * Math.sin(-midAngle * RADIAN);
        const p = percent || 0; // handle case where percent is undefined

        return (
            <text x={x} y={y} fill="white" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central">
                {`${(p * 100).toFixed(0)}%`}
            </text>
        );
    };

    return (
        <div className="space-y-6">
            <PageTitle title="Dashboard" subtitle={`Welcome back, ${auth?.currentUser?.firstName}!`} />
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                <StatCard title="Enrolled Courses" value={enrolledCount} icon={<BookOpenIcon />} color="bg-gradient-to-r from-blue-500 to-blue-400" />
                <StatCard title="Active Courses" value={activeCount} icon={<PlayCircleIcon />} color="bg-gradient-to-r from-green-500 to-green-400" />
                <StatCard title="Completed Courses" value={completedCount} icon={<CheckCircleIcon />} color="bg-gradient-to-r from-yellow-500 to-yellow-400" />
                <StatCard title="Certificates Earned" value={certificatesCount} icon={<AwardIcon />} color="bg-gradient-to-r from-red-500 to-red-400" />
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                <Card className="lg:col-span-2 p-4">
                    <h3 className="font-bold text-lg mb-4 text-gray-800">Course Status</h3>
                    <ResponsiveContainer width="100%" height={300}>
                        <PieChart>
                            <Pie
                                data={statusData}
                                dataKey="value"
                                nameKey="name"
                                cx="50%"
                                cy="50%"
                                outerRadius={120}
                                labelLine={false}
                                label={renderCustomizedLabel}
                            >
                                {statusData.map((entry, index) => (
                                    <Cell key={`cell-${index}`} fill={PIE_CHART_COLORS[index % PIE_CHART_COLORS.length]} />
                                ))}
                            </Pie>
                            <Tooltip />
                            <Legend />
                        </PieChart>
                    </ResponsiveContainer>
                </Card>
                <Card className="p-4">
                    <h3 className="font-bold text-lg mb-4 text-gray-800">Overall Completion</h3>
                     <ResponsiveContainer width="100%" height={300}>
                        <RadialBarChart 
                            innerRadius="70%" 
                            outerRadius="90%" 
                            data={radialChartData} 
                            startAngle={90} 
                            endAngle={-270}
                        >
                            <PolarAngleAxis
                                type="number"
                                domain={[0, 100]}
                                angleAxisId={0}
                                tick={false}
                            />
                            <RadialBar
                                background
                                dataKey="value"
                                cornerRadius={10}
                            />
                             <text
                                x="50%"
                                y="50%"
                                textAnchor="middle"
                                dominantBaseline="middle"
                                className="text-4xl font-bold fill-current text-gray-800"
                            >
                                {`${Math.round(overallCompletion)}%`}
                            </text>
                        </RadialBarChart>
                    </ResponsiveContainer>
                </Card>
            </div>
        </div>
    );
};

const OfflineDashboard = () => {
    const auth = useContext(AuthContext);
    const [dashboardData, setDashboardData] = useState<TraineeDashboardResponse | null>(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    // Fetch dashboard data from API
    useEffect(() => {
        const fetchDashboardData = async () => {
            // Get TraineeToken from localStorage
            const traineeToken = localStorage.getItem('TraineeToken');
            
            if (!traineeToken) {
                console.log('No TraineeToken found in localStorage');
                setError('Authentication token not found. Please login again.');
                setIsLoading(false);
                return;
            }
            
            try {
                setIsLoading(true);
                setError(null);
                console.log('Fetching trainee dashboard with token:', traineeToken);
                
                // Call the API with TraineeToken
                const data = await getTraineeDashboard(traineeToken);
                console.log('Dashboard API response:', data);
                
                setDashboardData(data);
            } catch (err: any) {
                console.error("Error fetching dashboard data:", err);
                setError(err.response?.data?.message || "Failed to load dashboard data");
                // Fallback to mock data if API fails - using your API response structure
                const mockResponse: TraineeDashboardResponse = {
                    statusCounts: { TOD123: 2, INP123: 1, INR123: 3, DON123: 2 },
                    priorityCounts: { low: 0, medium: 4, high: 1, critical: 0 }
                };
                setDashboardData(mockResponse);
            } finally {
                setIsLoading(false);
            }
        };

        fetchDashboardData();
    }, []); // Empty dependency array since we're using localStorage

    // Calculate task stats from API response
    const taskStats = useMemo(() => {
        if (!dashboardData) {
            return { total: 0, todo: 0, inProgress: 0, inReview: 0, completed: 0 };
        }

        const { statusCounts } = dashboardData;
        
        const todo = statusCounts.TOD123 || 0;
        const inProgress = statusCounts.INP123 || 0;
        const inReview = statusCounts.INR123 || 0;
        const completed = statusCounts.DON123 || 0;
        
        const total = todo + inProgress + inReview + completed;

        return { total, todo, inProgress, inReview, completed };
    }, [dashboardData]);

    // Prepare chart data from API response
    const statusData = useMemo(() => {
        if (!dashboardData) return [];

        const { statusCounts } = dashboardData;
        
        return [
            { name: 'To Do', value: statusCounts.TOD123 || 0 },
            { name: 'In Progress', value: statusCounts.INP123 || 0 },
            { name: 'In Review', value: statusCounts.INR123 || 0 },
            { name: 'Completed', value: statusCounts.DON123 || 0 },
        ];
    }, [dashboardData]);

    const priorityData = useMemo(() => {
        if (!dashboardData) return [];

        const { priorityCounts } = dashboardData;
        
        return [
            { name: 'Low', count: priorityCounts.low || 0 },
            { name: 'Medium', count: priorityCounts.medium || 0 },
            { name: 'High', count: priorityCounts.high || 0 },
            // { name: 'Critical', count: priorityCounts.critical || 0 },
        ];
    }, [dashboardData]);
    
    const RADIAN = Math.PI / 180;
    const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, value, index }: any) => {
        const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
        const x = cx + radius * Math.cos(-midAngle * RADIAN);
        const y = cy + radius * Math.sin(-midAngle * RADIAN);

        return (
            <text x={x} y={y} fill="white" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central" className="font-bold text-sm">
                {value}
            </text>
        );
    };

    if (isLoading) {
        return (
            <div className="space-y-6">
                <PageTitle title="Dashboard" subtitle="Here's a quick overview of your tasks." />
                <div className="grid grid-cols-5 gap-6">
                    {[...Array(5)].map((_, i) => <LoadingSkeleton key={i} className="h-28 rounded-xl" />)}
                </div>
                <div className="grid grid-cols-1 lg:grid-cols-5 gap-6">
                    <LoadingSkeleton className="lg:col-span-2 h-80 rounded-xl" />
                    <LoadingSkeleton className="lg:col-span-3 h-80 rounded-xl" />
                </div>
            </div>
        );
    }

    if (error && !dashboardData) {
        return (
            <div className="space-y-6">
                <PageTitle title="Dashboard" subtitle="Here's a quick overview of your tasks." />
                <div className="bg-red-50 border border-red-200 rounded-lg p-4">
                    <p className="text-red-800">Error: {error}</p>
                    <button 
                        onClick={() => window.location.reload()} 
                        className="mt-2 px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
                    >
                        Retry
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className="space-y-6">
            <PageTitle title="Dashboard" subtitle="Here's a quick overview of your tasks." />
            {error && (
                <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
                    <p className="text-yellow-800">Note: {error} Showing fallback data.</p>
                </div>
            )}
            {/* Updated grid to show all 5 cards in one line */}
            <div className="grid grid-cols-5 gap-6">
                <StatCard title="TOTAL TASK" value={taskStats.total} icon={<ClipboardListIcon />} color="bg-gradient-to-r from-yellow-500 to-yellow-400" />
                <StatCard title="TO DO" value={taskStats.todo} icon={<ListTodoIcon />} color="bg-gradient-to-r from-orange-500 to-orange-400" />
                <StatCard title="IN PROGRESS" value={taskStats.inProgress} icon={<RefreshCwIcon />} color="bg-gradient-to-r from-red-500 to-red-400" />
                <StatCard title="IN REVIEW" value={taskStats.inReview} icon={<EyeIcon />} color="bg-gradient-to-r from-blue-500 to-blue-400" />
                <StatCard title="COMPLETED" value={taskStats.completed} icon={<CheckCheckIcon />} color="bg-gradient-to-r from-green-500 to-green-400" />
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-5 gap-6">
                <Card className="lg:col-span-2 p-4">
                     <h3 className="font-bold text-lg mb-4 text-gray-800">Tasks by Status</h3>
                     <ResponsiveContainer width="100%" height={300}>
                         <PieChart>
                            <Pie
                                data={statusData}
                                dataKey="value"
                                nameKey="name"
                                cx="50%"
                                cy="50%"
                                outerRadius={100}
                                label={renderCustomizedLabel}
                                labelLine={false}
                            >
                                {statusData.map((entry, index) => (
                                    <Cell key={`cell-${index}`} fill={PIE_CHART_COLORS[index % PIE_CHART_COLORS.length]} />
                                ))}
                            </Pie>
                            <Tooltip />
                            <Legend />
                        </PieChart>
                     </ResponsiveContainer>
                </Card>
                 <Card className="lg:col-span-3 p-4">
                     <h3 className="font-bold text-lg mb-4 text-gray-800">Tasks by Priority</h3>
                     <ResponsiveContainer width="100%" height={300}>
                        <BarChart data={priorityData} margin={{ top: 5, right: 20, left: -10, bottom: 5 }}>
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="name" />
                            <YAxis allowDecimals={false} />
                            <Tooltip />
                            <Bar dataKey="count" name="Tasks">
                                 {priorityData.map((entry, index) => (
                                    <Cell key={`cell-${index}`} fill={BAR_CHART_COLORS[index % BAR_CHART_COLORS.length]} />
                                ))}
                            </Bar>
                        </BarChart>
                    </ResponsiveContainer>
                </Card>
            </div>
        </div>
    );
};

const DashboardPage: React.FC = () => {
    const auth = useContext(AuthContext);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => setIsLoading(false), 300);
        return () => clearTimeout(timer);
    }, []);

    if (isLoading || !auth?.currentUser) {
        return (
            <div>
                <LoadingSkeleton className="h-9 w-1/3 mb-4" />
                <LoadingSkeleton className="h-5 w-1/2 mb-8" />
                <div className="grid grid-cols-5 gap-6">
                    {[...Array(5)].map((_, i) => <LoadingSkeleton key={i} className="h-28 rounded-xl" />)}
                </div>
                 <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mt-6">
                    <LoadingSkeleton className="lg:col-span-2 h-80 rounded-xl" />
                    <LoadingSkeleton className="h-80 rounded-xl" />
                </div>
            </div>
        );
    }
    
    return auth.currentUser.mode === 'online' ? <OnlineDashboard /> : <OfflineDashboard />;
};

export default DashboardPage;